import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';


class SetupOperation extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {manageaction:'AUTO',NewApp:[],user:localStorage.getItem('tokens'), Resp:'',updaterole:'',management:'',
				roleforupdate:''};							
		this.handleChange=this.handleChange.bind(this)
		this.handleSubmit=this.handleSubmit.bind(this)
	}
	componentDidMount() {	
		const para={user:this.state.user}
		axios.post(process.env.REACT_APP_API_ENV+'api/autoday.php')
			.then(result => {																		
					this.setState({NewApp:result.data})				
			})												
	}

	handleChange = event => {				
		const {name, value} = event.target
		this.setState({[name]: value}) 		
		this.setState({Resp:''})
	}

	handleSubmit = event => {
		event.preventDefault()		
		const {updaterole,management,roleforupdate} = this.state		
		if(!updaterole){
			alert('Please select action')
			return false 
		} else if(updaterole === '1') {			
			if(!management){
				alert('Please select week day')
				return false 
			} 			
		} else if(updaterole === '2') {
			if(!roleforupdate){
				alert('Please select day to be deleted')
				return false
			} 
		}
		const userObject = {	
			user:this.state.user,
			manageaction:this.state.manageaction,
			updaterole:this.state.updaterole,			
			management:this.state.management,						
			roleforupdate:this.state.roleforupdate
		};
		axios.post(process.env.REACT_APP_API_ENV+'api/managementprocess.php', userObject)
			.then((res) => {
				this.setState({Resp:res.data})											
			}).catch((error) => {
				console.log(error)
			});
		
	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Auto Run"/>	
				<form onSubmit={this.handleSubmit}>
					<h3>Select Action</h3>
					<select name="updaterole" style={{width: '150px', border:'1px solid grey'}} value = {this.state.updaterole} onChange={this.handleChange}>
						<option value="">--Select--</option>		
						<option value="1">Add New Auto Day</option>				
						<option value="2">Delete Auto Day</option>						
					</select><br/><br/>	
					{(()=>{if(this.state.updaterole === "1") {return (<div>	
						<h3>New Day</h3>						
						<select name="management" style={{width: '150px', border:'1px solid grey'}} value = {this.state.management} onChange={this.handleChange}>
							<option value="">--Select--</option>		
							<option value="1">--Monday--</option>		
							<option value="2">--Tuesday--</option>		
							<option value="3">--Wednesday--</option>		
							<option value="4">--Thursday--</option>		
							<option value="5">--Friday--</option>							
						</select><br/><br/>
					<br/><br/>
					</div>)} else if(this.state.updaterole === "2") {return (<div>	
						<h3>Select Day to be deleted</h3>
						<select name="roleforupdate" style={{width: '150px', border:'1px solid grey'}} value = {this.state.roleforupdate} onChange={this.handleChange}>
							<option value="">--Select--</option>		
							{this.state.NewApp.map((sub,index) => (<option value={sub[0]} key={index}>{sub[1]}</option>))}							
						</select><br/><br/>	
					</div>)}})()}
					<h3>{this.state.Resp}</h3><br/><br/>
					<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
				</form>				
			</div>
		)
	}
}

export default SetupOperation